import { useEffect, useState,useContext } from "react";
import { useParams } from "react-router-dom";
import MyCards from "./MyCards";
import Account from "./account";
import Cashback from "./cashback";
import CommonProfile from "./common";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ClientContext } from "../../context/client/ClientContext";
const ProfileScreen = () => {

    const params = useParams();
    const menuItem = params.menuitem
    const tenanturl = params.tenanturlpathname;

    const [cbRewardList, setCBRewardList] = useState([]);
    const [cbMerchantList, setCBMerchantList] = useState([]);
    const [hideCommon, setHideCommon] = useState("d-block");
    const [isAccount, setIsAccount] = useState(true);
    const [isCashback, setIscashback] = useState(false);
    const [isCards, setIsCards] = useState(false);
    const [menuCurrentItem, setCurrentMenuItem] = useState('Account');
    const [loader, setLoader] = useState(true);
    const navigate = useNavigate();
    const { client } = useContext(ClientContext);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if ( !client && !isLoaded) {
            navigate(`/${tenanturl}/signin`);
        }else{
            setIsLoaded(true);
        }
    }, [client,isLoaded])

    useEffect(() => {
        if (menuItem === "mycards") {
            setIsCards(true);
            setIsAccount(false);
            setIscashback(false);
            setCurrentMenuItem("MyCards");
        } else if (menuItem === "account") {
            setIsAccount(true);
            setIscashback(false);
            setIsCards(false);
            setCurrentMenuItem("Account");
        } else if (menuItem === "cashback") {
            setIscashback(true);
            setIsCards(false);
            setIsAccount(false);
            setCurrentMenuItem("Cashback");
        }
     }, [menuItem])


    return (<div className="isn-page-bg pb-5">
        <div className="container">
            <div className="row mt-4">
                <div className="col-md-3">
                    <CommonProfile menuItem={menuCurrentItem}
                        CBRewardList={setCBRewardList}
                        CBMerchantList={setCBMerchantList}
                        hidecommon={hideCommon}
                        setLoader={setLoader} />
                </div>
                {isCashback ? <Cashback cbRewardList={cbRewardList} cbMerchantList={cbMerchantList} setHideCommon={setHideCommon} /> : null }
                {isAccount ? <Account /> : null}
                {isCards ? <MyCards />: null}
            </div>
            {
                (loader) ? <div className="ow-full-overlay">
                    <div className="position-absolute ow-content-center text-center">
                        <Spinner animation="border" backdrop="static" variant="light" />
                    </div>
                </div>
                    : ""
            }
        </div>
    </div>);
}

export default ProfileScreen;